import { Component } from '@angular/core'
import { FormControl, FormsModule } from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { BaseComponent, FuelEntry, ListItem } from '../../shared'

@Component({
    templateUrl: './lifetime-meter-entry.component.html',
    styleUrls: ['./lifetime-meter-entry.component.css'],
    standalone: true,
    imports: [FormsModule, WjInputModule, MatButton, FaIconComponent],
})
export class LifetimeMeterEntryComponent extends BaseComponent {
    myControl = new FormControl()
    faSpinner = faSpinner
    source = ''
    lifetimeMeter = 0
    lifetimeMeterIdOptions = [
        new ListItem('', ''),
        new ListItem('1', '1'),
        new ListItem('2', '2'),
        new ListItem('3', '3'),
    ] as ListItem<string>[]
    lifetimeMeterId = ''
    date = new Date()
    isSaving = false
    saved = false
    fuelSourceOptions: ListItem<string>[] = []
    fuelSources: any[] = []
    allEquipment: any[] = []

    constructor() {
        super()
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.get('api/VpEquipment'), this.services.data.vpJobs.queryAll()).subscribe({
                next: result => {
                    const items = (result[0] as any[]).orderBy(x => x.equipment)
                    this.allEquipment = result[0]
                    const fuelSources = [] as any[]

                    for (const item of items) {
                        if (item.udFueler === 'Y' && (item.equipment.startsWith('FT') || item.equipment.startsWith('FC'))) {
                            this.fuelSources.push(item)
                            fuelSources.push(new ListItem(item.equipment, item.equipment + ': ' + item.description))
                        }
                    }

                    this.fuelSourceOptions = fuelSources
                    this.reset()
                    this.initialLoadingComplete()
                },
            }),
        )
    }
    reset() {
        this.source = ''
        this.lifetimeMeter = 0
        this.saved = false
        this.lifetimeMeterId = ''
        this.date = new Date()
        setTimeout(() => {
            this.source = ''
        }, 10)
    }
    save() {
        this.isSaving = true
        const entry = new FuelEntry()
        entry.gallons = 0
        entry.meter = 0
        entry.source = this.source
        entry.vehicle = this.source
        entry.jobId = ''
        entry.date = this.date
        entry.lifetimeMeter = this.lifetimeMeter
        entry.lifetimeMeterId = this.lifetimeMeterId

        this.cancelableRequest(
            'saveEntry',
            true,
            this.services.data.load(true, true, this.services.data.fuelEntries.add(entry)).subscribe({
                next: () => {
                    this.saved = true
                    this.isSaving = false
                },
                error: () => {
                    this.isSaving = false
                    this.services.notification.error('There was a problem saving the lifetime meter entry.')
                },
            }),
        )
    }
}
